import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { SharingService } from 'media.sharing/services/sharing.service'
import { MediaPermissionsService } from 'media/services/mediaPermissions.service'
import { PanelService } from 'panel/services/panel.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class ShareOp extends BaseOperation {
  icon = 'fas fa-share-alt'
  showInToolbar = true
  showInSelectionToolbar = false
  showInContextMenu = true
  showInAssetView = false
  supportsMultiple = true
  supportsDirs = true
  supportsBundles = true
  weight = 85

  constructor (
    private translate: TranslateService,
    private sharing: SharingService,
    private panel: PanelService,
    private mediaPermissions: MediaPermissionsService,
  ) {
    super()
    this.label = translate.instant('Share')
  }

  isVisibleForBundle (bundle, context) {
    return !this.panel.active && this.mediaPermissions.getPermissionForBundle(bundle)?.allowSharing && context.permission && context.root
  }

  isVisibleForDir (dir, context) {
    return !this.panel.active && this.mediaPermissions.getPermissionForFile(dir)?.allowSharing && context.permission && context.root
  }

  async run ({ dirs, bundles }, context) {
    this.sharing.show(bundles, dirs, context.permission, context.root).catch(() => null)
  }
}

MediaOperationsService.register(ShareOp)
